import { QueryClient } from '@tanstack/vue-query'

/**
 * Shared QueryClient instance for TanStack Query
 * Configure default options for all queries and mutations here
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
})

// Expose to window for debugging (dev only)
if (import.meta.env.DEV) {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient
}

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__?: QueryClient
  }
}
